export const months = [
  {
    value: "فروردین",
    label: "فروردین",
  },
  { value: "اردیبهشت", label: "اردیبهشت" },
  { value: "خرداد", label: "خرداد" },
  { value: "تیر", label: "تیر" },
  { value: "مرداد", label: "مرداد" },
  { value: "شهریور", label: "شهریور" },
  { value: "مهر", label: "مهر" },
  { value: "آبان", label: "آبان" },
  { value: "آذر", label: "آذر" },
  { value: "دی", label: "دی" },
  { value: "بهمن", label: "بهمن" },
  { value: "اسفند", label: "اسفند" },
];
